import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateStoreDeliverySchedule(payload) {
    return requestPost(apiPath.STORE_DELIVERY_SCHEDULE.path, payload)
  },

  GetOneStoreDeliverySchedule(storeDeliveryScheduleID) {
    return requestGet(
      `${apiPath.STORE_DELIVERY_SCHEDULE.path}/${storeDeliveryScheduleID}`
    )
  },

  GetAllStoreDeliverySchedule(paging, sorting, filtering) {
    return requestGet(apiPath.STORE_DELIVERY_SCHEDULE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_orderType: filtering.orderType,
      f_status: filtering.status,
      f_beginDate: filtering.beginDate,
      f_endDate: filtering.endDate,
      f_beginDay: filtering.beginDay,
      f_endDay: filtering.endDay,
      f_beginHour: filtering.beginHour,
      f_endHour: filtering.endHour
    })
  },

  UpdateStoreDeliverySchedule(storeDeliveryScheduleID, payload) {
    return requestPut(
      `${apiPath.STORE_DELIVERY_SCHEDULE.path}/${storeDeliveryScheduleID}`,
      payload
    )
  },

  DeleteStoreDeliverySchedule(storeDeliveryScheduleID) {
    return requestDelete(
      `${apiPath.STORE_DELIVERY_SCHEDULE.path}/${storeDeliveryScheduleID}`
    )
  }
}

export default api
